import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import { Button, Typography } from "@mui/material";
import "./theme.scss";
import CardTheme from "../../../components/Card/CardTheme/CardTheme";
import * as themeService from "../../../services/ThemeService";
import Swal from "sweetalert2";
import Spinner from "../../../components/Spinner/Spinner";
import SearchBar from "../../../components/Search/SearchBar";

const ShowTheme = () => {
  const [theme, setTheme] = useState([]);
  const [isLoading, setIsLoading] = useState(true);
  const [filterTitle, setFilterTitle] = useState("");

  useEffect(() => {
    themeService
      .getAllTheme()
      .then((themes) => {
        setTheme(themes);
        setIsLoading(false);
      })
      .catch((error) => {
        console.error(
          "Erreur lors du chargement des données Teny Zaraina :",
          error
        );
        setIsLoading(false);
      });
  }, []);

  const handleDelete = async (id) => {
    const isConfirmed = await Swal.fire({
      title: "Êtes-vous sûr de vouloir supprimer ce thème ?",
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#3085d6",
      cancelButtonColor: "#d33",
      confirmButtonText: "Oui, supprimer!",
      cancelButtonText: "Annuler",
    });

    if (isConfirmed.isConfirmed) {
      try {
        const response = await themeService.deleteThemeById(id);
        if (response && (response.status === 200 || response.status === 204)) {
          Swal.fire("Thème supprimé !", "Suppression réussie", "success");
          let newTheme = theme.filter((themes) => themes.id !== id);
          setTheme(newTheme);
        } else {
          Swal.fire("Erreur", "La suppression a échoué", "error");
        }
      } catch (error) {
        console.error("Erreur lors de la suppression du thème :", error);
        Swal.fire("Erreur", "Une erreur s'est produite", "error");
      }
    }
  };

  const handleSearch = (value) => {
    setFilterTitle(value);
  };

  return (
    <div className="theme-component">
      <div className="add-button">
        <Link to="/theme/addTheme">
          <Button>Créer un Thème</Button>
        </Link>
      </div>

      <div
        style={{
          display: "flex",
          justifyContent: "center",
          marginBottom: "15px",
        }}
      >
        <SearchBar onSearch={handleSearch} />
      </div>

      {isLoading ? (
        <Spinner />
      ) : (
        <div className="theme">
          {theme && theme.length > 0 ? (
            theme
              .filter((themes) =>
                themes.nomTheme
                  .toLowerCase()
                  .includes(filterTitle.toLowerCase())
              )
              .map((themes) => (
                <CardTheme
                  key={themes.id}
                  themes={themes}
                  handleDelete={() => handleDelete(themes.id)}
                />
              ))
          ) : (
            <Typography variant="h6">Il n'y a pas de thème.</Typography>
          )}
        </div>
      )}
    </div>
  );
};

export default ShowTheme;
